import { forEachDataText } from './data-strings.js';
import { DATA_EN } from './data/index.js';
import { language } from './language.js';

/**
 * The game data in English (ADR 0069, step 3), put in place once at start,
 * before any window or sprite reads it: every item, creature, spell, quest
 * and place text found in `@shefira/shared` is swapped for its English.
 * Imported first by `main.ts`. The server keeps the French: it only sends
 * ids, and the few phrases it writes are translated on arrival.
 */
if (language() === 'en') {
  forEachDataText(({ text, replace, inPlace }) => {
    const english = DATA_EN[text];
    if (english !== undefined && inPlace) replace(english);
  });
}
